/* ============================================
   Dhenika — APP INFO
   Update download links here when published.
   ============================================ */

const appInfo = {
  name: 'DHENIKA',
  tagline: 'Care for your animals, the smart way.',
  description:
    'Dhenika helps farmers track every detail of their livestock — health records, vaccinations, breeding and timely reminders — all in one place.',
  shortDescription:
    'Smart livestock management for every Indian farmer.',

  // ── Update these when your app is published ──
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.dhenika.app',       // https://play.google.com/store/apps/details?id=...
  appStoreUrl:  '#',       // https://apps.apple.com/app/...
  apkUrl:       '#',       // direct APK download if needed

  // ── Contact ──
  supportEmail: 'dhenikasupport@gmail.com',
  website:      'https://Dhenika.com',

  // ── Stats shown in hero ──
  stats: [
    { number: '5K+',  label: 'Farmers Using'    },
    { number: '50K+', label: 'Animals Tracked'  },
    { number: '4.8★', label: 'App Rating'        },
  ],

  // ── Social links (add when ready) ──
  social: {
    instagram: '#',
    facebook:  '#',
    twitter:   '#',
  },
};

export default appInfo;